module.exports = __webpack_public_path__ + "static/media/pay-mortgage.f43cab71.svg";